import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';

const Pricing = ({ currency, total }) => {
  const sign = I18n.t(`number.currency.${currency.toUpperCase()}`);

  const price = I18n.number(total, {
    precision: 0,
  });

  const currencyTag = currency.toUpperCase() === 'USD' ? <sup>USD</sup> : null;

  return (
    <React.Fragment>
      <span>
        {sign}
        {price}
      </span>
      {currencyTag}
    </React.Fragment>
  );
};

Pricing.propTypes = {
  currency: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
};

export default React.memo(Pricing);
